<template>
  <div name="stdapplinf-detail-pg10">
    <div class="clearfix"></div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['10'] }}</label>
          <hrms-dropdown  v-model="numseq"
                          :options="numseqDropdown"
                          :showNone="false" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['20'] }}</label>
          <div class="form-control readonly-field-color">{{ detailTapplref.namref }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ labels['60'] }}</label>
          <div class="form-control readonly-field-color">{{ detailTapplref.flgref }} - {{ detailTapplref.desc_flgref }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['30'] }}</label>
          <div class="form-control readonly-field-color">{{ detailTapplref.despos }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ labels['70'] }}</label>
          <div class="form-control readonly-field-color">{{ detailTapplref.desnoffi }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['80'] }}</label>
          <div class="form-control readonly-field-color">{{ detailTapplref.numtele }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ labels['90'] }}</label>
          <div class="form-control readonly-field-color">{{ detailTapplref.email }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['40'] }}</label>
          <textarea class="form-control"
                    :value="detailTapplref.adrcont1"
                    readonly />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['100'] }}</label>
          <textarea class="form-control"
                    :value="detailTapplref.remark"
                    readonly />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['50'] }}</label>
          <div class="form-control readonly-field-color">{{ detailTapplref.codoccup }} - {{ detailTapplref.ti_codoccup }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-md-offset-2">
        <div class="form-group">
          <label>{{ labels['110'] }}</label>
          <div class="form-control readonly-field-color">{{ setDateOutput(detailTapplref.dteupd) }}</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>{{ labels['120'] }}</label>
          <div class="form-control readonly-field-color">{{ detailTapplref.coduser }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'stdapplinf-detail-pg10',
  data () {
    return {
      numseq: ''
    }
  },
  computed: {
    numseqDropdown () {
      let index = 0
      let dropdown = {}
      this.data.rows.map((row, key) => {
        if (index === 0) {
          this.numseq = row.numseq
        }
        index += 1
        dropdown[row.numseq] = row.numseq
        return row
      })
      return dropdown
    },
    detailTapplref () {
      if (this.data.rows.length <= 0) {
        return {
          namref: '',
          despos: '',
          adrcont1: '',
          codoccup: '',
          desc_codoccup: '',
          ti_flgref: '',
          desnoffi: '',
          numtele: '',
          email: '',
          remark: '',
          dteupd: '',
          coduser: ''
        }
      }
      return this.data.rows.filter((row) => {
        return row.numseq === this.numseq
      }).pop()
    }
  },
  props: [ 'labels', 'data' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>


// WEBPACK FOOTER //
// stdapplinfDetailPg10.vue?54ed00e9